import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Coa4 from "../../../containers/modules/accounting/coa4";
import AccSetup from "../../../containers/modules/accounting/acc-setup";

export default function AccountingSetupRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="configuration"
      index
      element={
        <AccessControl
          name={"Acc Setup List"}
          auth={authUser}
          component={() => <AccSetup />}
        />
      }
    />
  );
}
